<template>
  <div>
    <ValidationObserver ref="formModalValidate">
      <b-row>
        <b-col cols="12">
            <ValidationProvider name="classroom_type" rules="" v-slot="{valid, errors}">
                <b-form-group :label="$t('private_classroom')">
                    <parameter-selectbox
                        :validate-error="errors[0]"
                        code="classroom_types"
                        v-model="form.classroom_type"
                    ></parameter-selectbox>
                </b-form-group>
            </ValidationProvider>
        </b-col>
        <b-col cols="12">
            <ValidationProvider name="status" rules="" v-slot="{valid, errors}">
                <b-form-group :label="$t('is_in_program')">
                    <parameter-selectbox
                        :validate-error="errors[0]"
                        code="instructor_exam_request_statuses"
                        v-model="form.status"
                    ></parameter-selectbox>
                </b-form-group>
            </ValidationProvider>
        </b-col>
        <b-col cols="12">
          <ValidationProvider
              name="explanation"
              rules=""
              v-slot="{ valid, errors }"
          >
            <b-form-group :label="$t('explanation')">
              <b-form-input
                  v-model="form.explanation"
              ></b-form-input>
              <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-row>
      <div class="col-12 mt-3 d-flex">
        <b-button @click="updateForm"
                  :disabled="formLoading"
                  type="button"
                  variant="primary"
                  class="btn-lg mr-2">
          {{ $t('save').toLocaleUpperCase('tr-TR') }}
        </b-button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
//Component
//Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
//Service
import instructorExamRequestAdminService from "@/services/instructorExamRequestAdminService";
import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";

export default {
  components: {
    ClassroomSelectbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    formId: {
      type: Number,
    },
  },
  data() {
    return {
      formLoading: false,
      form: {
        classroom_type: null,
        explanation: null,
        status: null,
      }
    }
  },
  watch: {
    formId: function (val) {
      this.get(val)
    }
  },
  async created() {
    await this.get(this.formId)
  },
  methods: {
    get(id) {
      this.formLoading = true;
      instructorExamRequestAdminService.get(id)
          .then((response) => {
            this.form = response.data.data;
            this.formLoading = false;
          })
          .catch((error) => {
            if (error.data.message) {
              this.$toast.error(this.$t("api." + error.data.message));
            }
          });
    },
    async updateForm() {
      const isValid = await this.$refs.formModalValidate.validate();
      if (isValid && this.formId) {
        this.formLoading = true;
        instructorExamRequestAdminService.update(this.formId, this.form)
            .then(() => {
              this.formLoading = false;
              this.$toast.success(this.$t('proccess_success'));
              this.$emit("updateFormSuccess")
            })
            .catch((error) => {
              this.showErrors(error, this.$refs.formModalValidate)
            })
      }
    }
  }
}
</script>
